import {
  get,
  post,
} from '@/utils/request';

const url = 'card-ticket-add-records';

export function index(data) {
  return get({
    url,
    data,
  });
}

// 通过某条课次券办理申请
export function store(data) {
  return post({
    url,
    data,
  });
}
